import { useGet } from '../../../sharedModules/hooks/useQuery';
import { BackflowJobGroup } from '../../model';

const BACKFLOW_JOB_GROUPS_URL = '/backflows/backflow_job_groups';

export const defaultBackflowJobGroupFilters = {
  status_in: ['in_progress', 'not_started', 'overdue'],
  company_name_eq: 'all' as const,
};

export function useBackflowJobGroups(filterValues: any = defaultBackflowJobGroupFilters) {
  const params = {
    'ransack[backflow_dates_scheduled_date_gteq]': filterValues.backflow_dates_scheduled_date_gteq,
    'ransack[backflow_dates_scheduled_date_lteq]': filterValues.backflow_dates_scheduled_date_lteq,
    'ransack[status_in]': filterValues.status_in?.length > 0 ? filterValues.status_in : undefined,
    'ransack[company_name_eq]': filterValues.company_name_eq !== 'all' ? filterValues.company_name_eq : undefined,
  };

  return useGet<{ result: BackflowJobGroup[] }>({ url: BACKFLOW_JOB_GROUPS_URL, params });
}

export const defaultBackflowApprovalQueueFilters = {
  company_name_eq: 'all' as const,
};

export function useBackflowApprovalQueue(
  filterValues: any = defaultBackflowApprovalQueueFilters,
  options?: { enabled?: boolean },
) {
  const params = {
    'ransack[backflow_dates_scheduled_date_gteq]': filterValues.backflow_dates_scheduled_date_gteq,
    'ransack[backflow_dates_scheduled_date_lteq]': filterValues.backflow_dates_scheduled_date_lteq,
    'ransack[status_eq]': 'pending_approval',
    'ransack[company_name_eq]': filterValues.company_name_eq !== 'all' ? filterValues.company_name_eq : undefined,
  };

  return useGet<{ result: BackflowJobGroup[] }>({ url: BACKFLOW_JOB_GROUPS_URL, params, enabled: options?.enabled });
}
